<template>
  <div v-if="loadTable" id="show-package-info">
    <div class="vx-row">
      <div class="vx-col w-full mb-2">
        <b>{{ $t("OrderNumber") }}:</b>
        <!-- <b
          v-if="
            packageInfo.stockDraftOrderContractInfoQuery &&
              packageInfo.stockDraftOrderContractInfoQuery.id
          "
        >
          {{
            "APO-" +
              packageInfo.stockDraftOrderContractInfoQuery.id +
              packageInfo.basketId
          }}
        </b> -->
        <b>
          {{ "APO-" + packageInfo.basketId }}
        </b>
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col lg:w-1/2 sm:w-1/2 w-full">
        <div class="vx-card mb-4">
          <div class="vx-card__header">
            <div class="vx-card__title">
              <h4>{{ $t("PartyInfo") }}</h4>
            </div>
          </div>
          <div class="vx-card__collapsible-content vs-con-loading__container">
            <div class="vx-card__body custom-tbl v-table">
              <vs-table :data="packageInfo" ref="table">
                <template :name="{ data }" slot-scope="{ data }">
                  <vs-tr>
                    <vs-td
                      v-if="
                        packageInfo.partyTypeQuery == 2 ||
                          packageInfo.partyTypeQuery == 4
                      "
                    >
                      {{ $t("CompanyName") }}
                    </vs-td>
                    <vs-td
                      v-if="
                        packageInfo.partyTypeQuery == 1 ||
                          packageInfo.partyTypeQuery == 3
                      "
                    >
                      {{ $t("CustomerName") }}
                    </vs-td>
                    <vs-td>
                      {{ packageInfo.stockDraftOrderPartyInfoQuery.name }}
                    </vs-td>
                  </vs-tr>
                  <vs-tr
                    v-if="
                      packageInfo.partyTypeQuery == 2 ||
                        packageInfo.partyTypeQuery == 4
                    "
                  >
                    <vs-td>
                      {{ $t("CompanyRegistrationNumber") }}
                    </vs-td>
                    <vs-td>
                      {{
                        packageInfo.stockDraftOrderPartyInfoQuery
                          .companyRegistrationNumber
                      }}
                    </vs-td>
                  </vs-tr>
                  <vs-tr
                    v-if="
                      packageInfo.partyTypeQuery == 2 ||
                        packageInfo.partyTypeQuery == 4
                    "
                  >
                    <vs-td>
                      {{ $t("EconomicCode") }}
                    </vs-td>
                    <vs-td>
                      {{
                        packageInfo.stockDraftOrderPartyInfoQuery.economicCode
                      }}
                    </vs-td>
                  </vs-tr>
                  <vs-tr
                    v-if="
                      packageInfo.partyTypeQuery == 1 ||
                        packageInfo.partyTypeQuery == 3
                    "
                  >
                    <vs-td>
                      {{ $t("SocialSecurityNumber") }}
                    </vs-td>
                    <vs-td>
                      {{
                        packageInfo.stockDraftOrderPartyInfoQuery
                          .socialSecurityNumber
                      }}
                    </vs-td>
                  </vs-tr>
                  <vs-tr>
                    <vs-td>
                      {{ $t("Email") }}
                    </vs-td>
                    <vs-td>
                      <span
                        v-if="packageInfo.stockDraftOrderPartyInfoQuery.email"
                      >
                        {{ packageInfo.stockDraftOrderPartyInfoQuery.email }}
                      </span>
                      <span
                        v-if="!packageInfo.stockDraftOrderPartyInfoQuery.email"
                      >
                        -
                      </span>
                    </vs-td>
                  </vs-tr>
                  <vs-tr>
                    <vs-td>
                      {{ $t("PhoneNumber") }}
                    </vs-td>
                    <template
                      v-for="item in packageInfo.stockDraftOrderPartyInfoQuery
                        .phones"
                    >
                      <td v-if="item.area" :key="item.id" style="direction:ltr">
                        <span>{{ item.area }}-</span>
                        {{ item.number }}
                      </td>
                    </template>
                  </vs-tr>
                  <vs-tr>
                    <vs-td>
                      {{ $t("PostalCode") }}
                    </vs-td>
                    <template
                      v-for="item in packageInfo.stockDraftOrderPartyInfoQuery
                        .addressesInfos"
                    >
                      <td v-if="item.postalCode" :key="item.id">
                        {{ item.postalCode }}
                      </td>
                    </template>
                  </vs-tr>
                  <vs-tr>
                    <vs-td>
                      {{ $t("Address") }}
                    </vs-td>
                    <template
                      v-for="item in packageInfo.stockDraftOrderPartyInfoQuery
                        .addressesInfos"
                    >
                      <td v-if="item.provinceInfo.name" :key="item">
                        {{ item.provinceInfo.name }}-{{
                          item.provinceInfo.cityName
                        }}-{{ item.address }}
                      </td>
                    </template>
                  </vs-tr>
                </template>
              </vs-table>
            </div>
          </div>
        </div>
      </div>
      <div class="vx-col lg:w-1/2 sm:w-1/2 w-full">
        <div class="vx-card mb-4">
          <div class="vx-card__header">
            <div class="vx-card__title">
              <h4>{{ $t("RecipientInfo") }}</h4>
            </div>
          </div>
          <div class="vx-card__collapsible-content vs-con-loading__container">
            <div class="vx-card__body custom-tbl v-table">
              <vs-table
                :data="packageInfo.stockDraftOrderRecipientInfoQuery"
                ref="table"
              >
                <template :name="{ data }" slot-scope="{ data }">
                  <vs-tr>
                    <vs-td>
                      {{ $t("FullName") }}
                    </vs-td>
                    <vs-td>
                      {{
                        packageInfo.stockDraftOrderRecipientInfoQuery.fullName
                      }}
                    </vs-td>
                  </vs-tr>
                  <vs-tr>
                    <vs-td>
                      {{ $t("PhoneNumber") }}
                    </vs-td>
                    <vs-td>
                      {{
                        packageInfo.stockDraftOrderRecipientInfoQuery
                          .phoneNumber
                      }}
                    </vs-td>
                  </vs-tr>
                  <vs-tr>
                    <vs-td>
                      {{ $t("PostalCode") }}
                    </vs-td>
                    <vs-td>
                      {{
                        packageInfo.stockDraftOrderRecipientInfoQuery
                          .addressInfo.postalCode
                      }}
                    </vs-td>
                  </vs-tr>
                  <vs-tr>
                    <vs-td>
                      {{ $t("Address") }}
                    </vs-td>
                    <vs-td>
                      {{
                        packageInfo.stockDraftOrderRecipientInfoQuery
                          .addressInfo.provinceInfo.name
                      }}-
                      {{
                        packageInfo.stockDraftOrderRecipientInfoQuery
                          .addressInfo.provinceInfo.cityName
                      }}-
                      {{
                        packageInfo.stockDraftOrderRecipientInfoQuery
                          .addressInfo.address
                      }}
                    </vs-td>
                  </vs-tr>
                  <vs-tr>
                    <vs-td>
                      {{ $t("InvoiceRequired") }}
                    </vs-td>
                    <vs-td v-if="packageInfo.invoiceRequire == true">
                      {{ $t("Yes") }}
                    </vs-td>
                    <vs-td v-if="packageInfo.invoiceRequire == false">
                      {{ $t("No") }}
                    </vs-td>
                  </vs-tr>
                  <vs-tr class="hide-in-print">
                    <vs-td class="white">
                      -
                    </vs-td>
                    <vs-td class="white">
                      -
                    </vs-td>
                  </vs-tr>
                  <vs-tr
                    v-if="
                      packageInfo.partyTypeQuery == 2 ||
                        packageInfo.partyTypeQuery == 4
                    "
                    class="hide-in-print"
                  >
                    <vs-td class="white">
                      -
                    </vs-td>
                    <vs-td class="white">
                      -
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="vx-card mb-4">
          <div class="vx-card__header">
            <div class="vx-card__title w-full">
              <h4>
                {{ $t("OrdersList") }}
                <span class="date">
                  <span> {{ $t("CreateOn") }}: </span>
                  <span class="float-right" style="direction: ltr;">
                    {{ packageInfo.persianDateTime }}
                  </span>
                </span>
              </h4>
            </div>
          </div>
          <div class="vx-card__collapsible-content vs-con-loading__container">
            <div class="vx-card__body custom-tbl" id="draft-order-tbl">
              <vs-table :data="packageInfo.packageItemQueries" ref="table">
                <template slot="thead">
                  <vs-th style="width:3%">#</vs-th>
                  <vs-th style="width:50%">{{ $t("ProductName") }}</vs-th>
                  <vs-th style="width:15%">{{ $t("ItemCode") }}</vs-th>
                  <vs-th style="width:10%">{{ $t("ProductColor") }}</vs-th>
                  <vs-th style="width:15%">{{ $t("ProductWarranty") }}</vs-th>
                  <vs-th style="width:7%">{{ $t("Count") }}</vs-th>
                </template>
                <template slot-scope="{ data }">
                  <vs-tr
                    v-for="(tr, indextr) in data"
                    :data="tr"
                    :key="indextr"
                  >
                    <vs-td :data="data[indextr]">
                      {{ parseInt(indextr) + 1 }}
                    </vs-td>
                    <vs-td :data="data[indextr].productName">
                      {{ data[indextr].productName }}
                    </vs-td>
                    <vs-td :data="data[indextr].itemCode">
                      {{ data[indextr].itemCode }}
                    </vs-td>
                    <vs-td :data="data[indextr].productColor">
                      {{ data[indextr].productColor }}
                    </vs-td>
                    <vs-td :data="data[indextr].productWarranty">
                      {{ data[indextr].productWarranty }}
                    </vs-td>
                    <vs-td :data="data[indextr].count">
                      {{ data[indextr].count }}
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="vx-row hide-in-print">
      <div class="vx-col w-full mt-2">
        <vs-button
          type="button"
          icon="print"
          class="float-right  purple"
          @click.prevent="printWindow()"
          >{{ $t("Print") }}</vs-button
        >
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import "@/assets/scss/vuesax-rtl/pages/_custom.scss";
import "@/assets/scss/vuesax-rtl/pages/_packageInfo.scss";
import "@/assets/scss/vuesax-rtl/pages/_webOrderdetails.scss";

export default {
  name: "warehouseManagement_ShowPackageInfo_Details",
  data() {
    return {
      loadTable: false,
      disabled: false,
      disabledReject: false
    };
  },
  computed: {
    ...mapGetters({
      packageInfo: "inventoryTransaction/packageInfoDetails"
    })
  },
  mounted() {
    this.load();
    setTimeout(() => {
      this.loadTable = true;
    }, 1500);
  },
  methods: {
    ...mapActions({
      fetchPackagesInfo: "inventoryTransaction/fetchPackagesInfo"
    }),
    load() {
      var id = this.$route.params.id;
      var stockDraftOrderId = this.$route.params.stockDraftOrderId;
      this.fetchPackagesInfo({ id, stockDraftOrderId });
    },
    printWindow() {
      window.print();
    }
  }
};
</script>
